var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5264 10.0182C28.7362 9.4425 28.2646 8.48088 28.2646 7.43963V7.02925C29.165 7.02925 29.9 6.29425 29.9 5.39388V2.13538C29.9 1.235 29.165 0.5 28.2646 0.5H21.7354C20.835 0.5 20.1 1.235 20.1 2.13538V5.4C20.1 6.30037 20.835 7.03538 21.7354 7.03538V7.44575C21.7354 8.48088 21.2637 9.44863 20.4797 10.0244C19.2241 10.9431 18.4707 12.4254 18.4707 13.9811V16.8415V17.0436V26.1454V26.6415V47.05C18.4707 48.4036 19.5671 49.5 20.9207 49.5H29.0854C30.439 49.5 31.5354 48.4036 31.5354 47.05V26.6354V17.0375V16.8354V13.975C31.5354 12.4193 30.782 10.937 29.5264 10.0182ZM30.4635 26.1699H19.5365V18.1951H30.4696V26.1699H30.4635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandWater);
export default __webpack_public_path__ + "static/media/brandWater.2e7dc7461223764ec5701eb1ef740e0f.svg";
export { ForwardRef as ReactComponent };